import { render, staticRenderFns } from "./DeleteTag.vue?vue&type=template&id=6b7b75e5&scoped=true"
import script from "./DeleteTag.vue?vue&type=script&lang=js"
export * from "./DeleteTag.vue?vue&type=script&lang=js"
import style0 from "./DeleteTag.vue?vue&type=style&index=0&id=6b7b75e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7b75e5",
  null
  
)

export default component.exports